module.exports = __webpack_public_path__ + "img/creditcard_white.96bff4ad.png";